import { render, staticRenderFns } from "./RadioButtonBox.vue?vue&type=template&id=c07da026&scoped=true&"
import script from "./RadioButtonBox.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonBox.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtonBox.vue?vue&type=style&index=0&id=c07da026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07da026",
  null
  
)

export default component.exports